import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { createKey as y } from "../../../_utils/cssr/index.js";
import ye from "../../focus-detector/src/FocusDetector.js";
import { internalSelectionMenuInjectionKey as Re, internalSelectionMenuBodyInjectionKey as Se } from "./interface.js";
import k from "./SelectGroupHeader.js";
import O from "./SelectOption.js";
import xe from "./styles/index.cssr.js";
import w from "../../../_mixins/use-theme.js";
import Fe from "../../../_mixins/use-config.js";
import { useRtl as Ce } from "../../../_mixins/use-rtl.js";
import Te from "../styles/light.js";
import { createIndexGetter as Pe } from "../../../../../../../treemate@0.3.11/node_modules/treemate/es/utils.js";
import { depx as Me, getMargin as F } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/css/index.js";
import { useThemeClass as ze } from "../../../_mixins/use-css-vars-class.js";
import { useOnResize as Ne } from "../../../_utils/composable/use-resize.js";
import { resolveWrappedSlot as _, resolveSlot as ke } from "../../../_utils/vue/resolve-slot.js";
import Oe from "../../loading/src/Loading.js";
import we from "../../scrollbar/src/Scrollbar.js";
import _e from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/virtual-list/src/VirtualList.js";
import { happensIn as B } from "../../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/happens-in.js";
import Be from "../../../empty/src/Empty.js";
import { defineComponent as Le, computed as s, watch as L, nextTick as Ie, onBeforeUnmount as Ke, provide as I, onMounted as De, h as r } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as d, ref as R } from "../../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const un = Le({
  name: "InternalSelectMenu",
  props: Object.assign(Object.assign({}, w.props), {
    clsPrefix: {
      type: String,
      required: !0
    },
    scrollable: {
      type: Boolean,
      default: !0
    },
    treeMate: {
      type: Object,
      required: !0
    },
    multiple: Boolean,
    size: {
      type: String,
      default: "medium"
    },
    value: {
      type: [String, Number, Array],
      default: null
    },
    autoPending: Boolean,
    virtualScroll: {
      type: Boolean,
      default: !0
    },
    // show is used to toggle pending state initialization
    show: {
      type: Boolean,
      default: !0
    },
    labelField: {
      type: String,
      default: "label"
    },
    valueField: {
      type: String,
      default: "value"
    },
    loading: Boolean,
    focusable: Boolean,
    renderLabel: Function,
    renderOption: Function,
    nodeProps: Function,
    showCheckmark: {
      type: Boolean,
      default: !0
    },
    onMousedown: Function,
    onScroll: Function,
    onFocus: Function,
    onBlur: Function,
    onKeyup: Function,
    onKeydown: Function,
    onTabOut: Function,
    onMouseenter: Function,
    onMouseleave: Function,
    onResize: Function,
    resetMenuOnOptionsChange: {
      type: Boolean,
      default: !0
    },
    inlineThemeDisabled: Boolean,
    // deprecated
    onToggle: Function
  }),
  setup(t) {
    const {
      mergedClsPrefixRef: c,
      mergedRtlRef: l
    } = Fe(t), m = Ce("InternalSelectMenu", l, c), v = w("InternalSelectMenu", "-internal-select-menu", xe, Te, t, d(t, "clsPrefix")), a = R(null), o = R(null), g = R(null), S = s(() => t.treeMate.getFlattenedNodes()), K = s(() => Pe(S.value)), u = R(null);
    function D() {
      const {
        treeMate: e
      } = t;
      let n = null;
      const {
        value: i
      } = t;
      i === null ? n = e.getFirstAvailableNode() : (t.multiple ? n = e.getNode((i || [])[(i || []).length - 1]) : n = e.getNode(i), (!n || n.disabled) && (n = e.getFirstAvailableNode())), p(n || null);
    }
    function C() {
      const {
        value: e
      } = u;
      e && !t.treeMate.getNode(e.key) && (u.value = null);
    }
    let f;
    L(() => t.show, (e) => {
      e ? f = L(() => t.treeMate, () => {
        t.resetMenuOnOptionsChange ? (t.autoPending ? D() : C(), Ie(M)) : C();
      }, {
        immediate: !0
      }) : f == null || f();
    }, {
      immediate: !0
    }), Ke(() => {
      f == null || f();
    });
    const T = s(() => Me(v.value.self[y("optionHeight", t.size)])), E = s(() => F(v.value.self[y("padding", t.size)])), $ = s(() => t.multiple && Array.isArray(t.value) ? new Set(t.value) : /* @__PURE__ */ new Set()), V = s(() => {
      const e = S.value;
      return e && e.length === 0;
    });
    function A(e) {
      const {
        onToggle: n
      } = t;
      n && n(e);
    }
    function P(e) {
      const {
        onScroll: n
      } = t;
      n && n(e);
    }
    function H(e) {
      var n;
      (n = g.value) === null || n === void 0 || n.sync(), P(e);
    }
    function j() {
      var e;
      (e = g.value) === null || e === void 0 || e.sync();
    }
    function G() {
      const {
        value: e
      } = u;
      return e || null;
    }
    function U(e, n) {
      n.disabled || p(n, !1);
    }
    function W(e, n) {
      n.disabled || A(n);
    }
    function q(e) {
      var n;
      B(e, "action") || (n = t.onKeyup) === null || n === void 0 || n.call(t, e);
    }
    function J(e) {
      var n;
      B(e, "action") || (n = t.onKeydown) === null || n === void 0 || n.call(t, e);
    }
    function Q(e) {
      var n;
      (n = t.onMousedown) === null || n === void 0 || n.call(t, e), !t.focusable && e.preventDefault();
    }
    function X() {
      const {
        value: e
      } = u;
      e && p(e.getNext({
        loop: !0
      }), !0);
    }
    function Y() {
      const {
        value: e
      } = u;
      e && p(e.getPrev({
        loop: !0
      }), !0);
    }
    function p(e, n = !1) {
      u.value = e, n && M();
    }
    function M() {
      var e, n;
      const i = u.value;
      if (!i)
        return;
      const b = K.value(i.key);
      b !== null && (t.virtualScroll ? (e = o.value) === null || e === void 0 || e.scrollTo({
        index: b
      }) : (n = g.value) === null || n === void 0 || n.scrollTo({
        index: b,
        elSize: T.value
      }));
    }
    function Z(e) {
      var n, i;
      !((n = a.value) === null || n === void 0) && n.contains(e.target) && ((i = t.onFocus) === null || i === void 0 || i.call(t, e));
    }
    function ee(e) {
      var n, i;
      !((n = a.value) === null || n === void 0) && n.contains(e.relatedTarget) || (i = t.onBlur) === null || i === void 0 || i.call(t, e);
    }
    I(Re, {
      handleOptionMouseEnter: U,
      handleOptionClick: W,
      valueSetRef: $,
      pendingTmNodeRef: u,
      nodePropsRef: d(t, "nodeProps"),
      showCheckmarkRef: d(t, "showCheckmark"),
      multipleRef: d(t, "multiple"),
      valueRef: d(t, "value"),
      renderLabelRef: d(t, "renderLabel"),
      renderOptionRef: d(t, "renderOption"),
      labelFieldRef: d(t, "labelField"),
      valueFieldRef: d(t, "valueField")
    }), I(Se, a), De(() => {
      const {
        value: e
      } = g;
      e && e.sync();
    });
    const z = s(() => {
      const {
        size: e
      } = t, {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          height: i,
          borderRadius: b,
          color: te,
          groupHeaderTextColor: oe,
          actionDividerColor: ie,
          optionTextColorPressed: le,
          optionTextColor: re,
          optionTextColorDisabled: ae,
          optionTextColorActive: de,
          optionOpacityDisabled: ue,
          optionCheckColor: se,
          actionTextColor: ce,
          optionColorPending: fe,
          optionColorActive: me,
          loadingColor: ve,
          loadingSize: he,
          optionColorActivePending: ge,
          [y("optionFontSize", e)]: pe,
          [y("optionHeight", e)]: be,
          [y("optionPadding", e)]: x
        }
      } = v.value;
      return {
        "--n-height": i,
        "--n-action-divider-color": ie,
        "--n-action-text-color": ce,
        "--n-bezier": n,
        "--n-border-radius": b,
        "--n-color": te,
        "--n-option-font-size": pe,
        "--n-group-header-text-color": oe,
        "--n-option-check-color": se,
        "--n-option-color-pending": fe,
        "--n-option-color-active": me,
        "--n-option-color-active-pending": ge,
        "--n-option-height": be,
        "--n-option-opacity-disabled": ue,
        "--n-option-text-color": re,
        "--n-option-text-color-active": de,
        "--n-option-text-color-disabled": ae,
        "--n-option-text-color-pressed": le,
        "--n-option-padding": x,
        "--n-option-padding-left": F(x, "left"),
        "--n-option-padding-right": F(x, "right"),
        "--n-loading-color": ve,
        "--n-loading-size": he
      };
    }), {
      inlineThemeDisabled: N
    } = t, h = N ? ze("internal-select-menu", s(() => t.size[0]), z, t) : void 0, ne = {
      selfRef: a,
      next: X,
      prev: Y,
      getPendingTmNode: G
    };
    return Ne(a, t.onResize), Object.assign({
      mergedTheme: v,
      mergedClsPrefix: c,
      rtlEnabled: m,
      virtualListRef: o,
      scrollbarRef: g,
      itemSize: T,
      padding: E,
      flattenedNodes: S,
      empty: V,
      virtualListContainer() {
        const {
          value: e
        } = o;
        return e == null ? void 0 : e.listElRef;
      },
      virtualListContent() {
        const {
          value: e
        } = o;
        return e == null ? void 0 : e.itemsElRef;
      },
      doScroll: P,
      handleFocusin: Z,
      handleFocusout: ee,
      handleKeyUp: q,
      handleKeyDown: J,
      handleMouseDown: Q,
      handleVirtualListResize: j,
      handleVirtualListScroll: H,
      cssVars: N ? void 0 : z,
      themeClass: h == null ? void 0 : h.themeClass,
      onRender: h == null ? void 0 : h.onRender
    }, ne);
  },
  render() {
    const {
      $slots: t,
      virtualScroll: c,
      clsPrefix: l,
      mergedTheme: m,
      themeClass: v,
      onRender: a
    } = this;
    return a == null || a(), r("div", {
      ref: "selfRef",
      tabindex: this.focusable ? 0 : -1,
      class: [`${l}-base-select-menu`, this.rtlEnabled && `${l}-base-select-menu--rtl`, v, this.multiple && `${l}-base-select-menu--multiple`],
      style: this.cssVars,
      onFocusin: this.handleFocusin,
      onFocusout: this.handleFocusout,
      onKeyup: this.handleKeyUp,
      onKeydown: this.handleKeyDown,
      onMousedown: this.handleMouseDown,
      onMouseenter: this.onMouseenter,
      onMouseleave: this.onMouseleave
    }, _(t.header, (o) => o && r("div", {
      class: `${l}-base-select-menu__header`,
      "data-header": !0,
      key: "header"
    }, o)), this.loading ? r("div", {
      class: `${l}-base-select-menu__loading`
    }, r(Oe, {
      clsPrefix: l,
      strokeWidth: 20
    })) : this.empty ? r("div", {
      class: `${l}-base-select-menu__empty`,
      "data-empty": !0
    }, ke(t.empty, () => [r(Be, {
      theme: m.peers.Empty,
      themeOverrides: m.peerOverrides.Empty,
      size: this.size
    })])) : r(we, {
      ref: "scrollbarRef",
      theme: m.peers.Scrollbar,
      themeOverrides: m.peerOverrides.Scrollbar,
      scrollable: this.scrollable,
      container: c ? this.virtualListContainer : void 0,
      content: c ? this.virtualListContent : void 0,
      onScroll: c ? void 0 : this.doScroll
    }, {
      default: () => c ? r(_e, {
        ref: "virtualListRef",
        class: `${l}-virtual-list`,
        items: this.flattenedNodes,
        itemSize: this.itemSize,
        showScrollbar: !1,
        paddingTop: this.padding.top,
        paddingBottom: this.padding.bottom,
        onResize: this.handleVirtualListResize,
        onScroll: this.handleVirtualListScroll,
        itemResizable: !0
      }, {
        default: ({
          item: o
        }) => o.isGroup ? r(k, {
          key: o.key,
          clsPrefix: l,
          tmNode: o
        }) : o.ignored ? null : r(O, {
          clsPrefix: l,
          key: o.key,
          tmNode: o
        })
      }) : r("div", {
        class: `${l}-base-select-menu-option-wrapper`,
        style: {
          paddingTop: this.padding.top,
          paddingBottom: this.padding.bottom
        }
      }, this.flattenedNodes.map((o) => o.isGroup ? r(k, {
        key: o.key,
        clsPrefix: l,
        tmNode: o
      }) : r(O, {
        clsPrefix: l,
        key: o.key,
        tmNode: o
      })))
    }), _(t.action, (o) => o && [r("div", {
      class: `${l}-base-select-menu__action`,
      "data-action": !0,
      key: "action"
    }, o), r(ye, {
      onFocus: this.onTabOut,
      key: "focus-detector"
    })]));
  }
});
export {
  un as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/select-menu/src/SelectMenu.js
// module id = 474
// module chunks = 67